import { render, staticRenderFns } from "./sex.vue?vue&type=template&id=31ee8af4&scoped=true&"
import script from "./sex.vue?vue&type=script&lang=js&"
export * from "./sex.vue?vue&type=script&lang=js&"
import style0 from "./sex.vue?vue&type=style&index=0&id=31ee8af4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ee8af4",
  null
  
)

export default component.exports